import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, anchors: true, lerp: 0.09 });
    window.__lenis = lenis;
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App grain bg-white text-zinc-900 min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" toastOptions={{
        style: { background: "#fff", border: "1px solid #e4e4e7", color: "#18181b" }
      }} />
    </div>
  );
}

export default App;
